module.exports = __webpack_public_path__ + "img/logo.bedaec9d.png";